module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-03.763f04b8.png";